import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CharityCommitment() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      className="py-6 sm:py-10 bg-[#F7F5F0] border-t-4 border-[#E8B84B]"
      ref={ref}
      aria-label="Community impact and charity commitment"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Header */}
        <div className={`text-center mb-4 sm:mb-7 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="inline-flex items-center gap-2 bg-white border border-[#D8D0BC] rounded-full px-3 py-1 mb-2 sm:mb-3">
            <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
              <i className="ri-heart-line" style={{ fontSize: '1rem', color: '#E8B84B' }}></i>
            </span>
            <span className="text-xs font-medium text-[#4A5568] uppercase tracking-wider">Community First</span>
          </div>
          <h2 className="text-xl sm:text-3xl font-bold text-[#1A2332]" style={{ fontFamily: 'Oswald, sans-serif' }}>
            We Give Back — Every Single Sale
          </h2>
        </div>

        {/* Two Cards Side by Side */}
        <div className={`grid sm:grid-cols-2 gap-3 sm:gap-4 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>

          {/* Card 1: Dog Rescue */}
          <div className="bg-white rounded-2xl border border-[#E8E2D6] p-4 sm:p-6 flex flex-col gap-3 sm:gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-[#E8F5E9] flex-shrink-0" aria-hidden="true">
                <i className="ri-footprint-line text-xl sm:text-2xl text-[#4CAF50]"></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-[#4CAF50] uppercase tracking-wider mb-0.5">$100 Per Sale</p>
                <h3 className="text-base sm:text-lg font-bold text-[#1A2332]" style={{ fontFamily: 'Oswald, sans-serif' }}>
                  Buy a Car. Save a Dog.
                </h3>
              </div>
            </div>
            <p className="text-sm text-[#4A5568] leading-relaxed">
              Every vehicle we sell sends <strong className="text-[#1A2332]">$100 directly to Oregon Dog Rescue</strong> — a no-kill, foster-based shelter. You get a great car. A dog gets a second chance.
            </p>
            <div className="mt-auto flex flex-row gap-2">
              <Link
                to="/community-impact"
                className="inline-flex items-center justify-center gap-1.5 bg-[#1A2332] hover:bg-[#2C3E55] text-[#E8B84B] px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 whitespace-nowrap"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                Our Impact →
              </Link>
              <a
                href="https://www.oregondogrescue.org"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 bg-white hover:bg-[#F7F5F0] text-[#1A2332] px-4 py-2 rounded-lg text-sm font-semibold border border-[#E8E2D6] hover:border-[#E8B84B] transition-all duration-300 whitespace-nowrap"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                ↗ Oregon Dog Rescue
              </a>
            </div>
          </div>

          {/* Card 2: Military Discount */}
          <div className="bg-[#1A2332] rounded-2xl border-2 border-[#E8B84B]/40 p-4 sm:p-6 flex flex-col gap-3 sm:gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-[#E8B84B]/10 border border-[#E8B84B]/30 flex-shrink-0" aria-hidden="true">
                <i className="ri-medal-line text-xl sm:text-2xl text-[#E8B84B]"></i>
              </div>
              <div>
                <div className="inline-flex items-center gap-1.5 bg-[#E8B84B]/10 border border-[#E8B84B]/30 rounded-full px-2.5 py-0.5 mb-0.5">
                  <span className="text-xs font-semibold text-[#E8B84B] uppercase tracking-wider">Military &amp; Veterans</span>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
                  Dog Tag Discount — <span className="text-[#E8B84B]">$300 Off</span>
                </h3>
              </div>
            </div>
            <p className="text-sm text-[#A0AEC0] leading-relaxed">
              Active duty, veterans, and military families get <strong className="text-white">$300 off any vehicle</strong> — or donate it to a charity of your choice. No DD-214 required.
            </p>
            <div className="mt-auto">
              <Link
                to="/military-discount"
                className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] hover:bg-[#D4A43A] text-[#1A2332] px-4 py-2 rounded-lg text-sm font-bold transition-all duration-300 whitespace-nowrap w-full sm:w-auto"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
                  <i className="ri-medal-line"></i>
                </span>
                Claim Your Discount →
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
